<template>
  <div class="finish-step">
    <upload-target-slot
      v-if="isPidListOrNPower"
      :onComplete="finishOnComplete"
      @submittedUploadFile="setOverrideBackButton"
    />
    <a-d-slot
      v-else-if="isAudienceDiscovery"
      :targetName="targetName"
      :onComplete="finishOnComplete"
      :title="title"
      :dataSourceIcon="dataSourceIcon"
    />
  </div>
</template>

<script>
  import UploadTargetSlot from '@/appComponents/targets/createTarget/targetSlots/UploadTargetSlot'
  import ADSlot from '@/appComponents/targets/createTarget/targetSlots/CreateADTargetSlot'
  import { DATASOURCES, TARGET_ACTIONS } from '@/appLogic/targets/Constants'
  import AmrldSelectedImg from '@/assets/dataSources/AMRLD-Selected.png'
  import MriSelectedImg from '@/assets/dataSources/MRI-Selected.png'
  import NcsSelectedImg from '@/assets/dataSources/Ncs-Selected.png'

  export default {
    components: {
      UploadTargetSlot,
      ADSlot,
    },
    props: {
      value: {
        completed: {
          type: Boolean,
          default: false,
        },
      },
      selectedDataSource: {
        type: String,
        default: null,
      },
      targetName: {
        type: String,
        default: '',
      },
      onComplete: {
        type: Function,
        default: () => {},
      },
      hideBackButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        overrideBackButton: false,
        title: {
          type: String,
          default: '',
        },
        dataSourceIcon: {
          type: String,
          default: null,
        },
      }
    },
    computed: {
      isLASTarget() {
        if (this.isAMRLD || this.isNCS || this.isMRI) {
          if (this.isMRI) {
            this.title = 'New MRI Target'
            this.dataSourceIcon = MriSelectedImg
          } else if (this.isAMRLD) {
            this.title = 'New AMRLD Target'
            this.dataSourceIcon = AmrldSelectedImg
          } else if (this.isNCS) {
            this.title = 'New NCS Target'
            this.dataSourceIcon = NcsSelectedImg
          }
          return true
        }
      },
      isAudienceDiscovery() {
        if (this.selectedDataSource === DATASOURCES.AUDIENCE_DISCOVERY) {
          const intentName =
            this.initialTarget &&
            this.initialTarget.metadata &&
            this.initialTarget.metadata.intents &&
            this.initialTarget.metadata.intents &&
            this.initialTarget.metadata.intents.length > 0 &&
            this.initialTarget.metadata.intents[0].Name
          this.title = this.isDuplicate ? `Copy ${intentName || 'AMRLD'} Target` : 'New AMRLD Target'
          this.dataSourceIcon = AmrldSelectedImg
          return true
        }
      },
      isAMRLD() {
        return this.selectedDataSource === DATASOURCES.AMRLD
      },
      isNCS() {
        return this.selectedDataSource === DATASOURCES.NCS
      },
      isMRI() {
        return this.selectedDataSource === DATASOURCES.MRI
      },
      isPidListOrNPower() {
        return this.selectedDataSource === DATASOURCES.FILE
      },
      showBackButton() {
        let dontShow = this.hideBackButton || this.overrideBackButton
        return !dontShow
      },
      isDuplicate() {
        return this.initialTargetAction === TARGET_ACTIONS.DUPLICATE
      },
      initialTargetAction() {
        return this.$store.state.createTarget.initialTargetAction
      },
      initialTarget() {
        return this.$store.state.createTarget.initialTarget
      },
    },
    methods: {
      finishOnComplete() {
        this.onComplete()
      },
      setOverrideBackButton() {
        this.overrideBackButton = true
      },
    },
  }
</script>

<style lang="scss">
  .finish-step {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// FinishStep.vue?f59fec82